import { TIERS_FILTER_OPTIONS } from '@/components/partials/jobs/JobsBackOffice/constants';
import { POSITION_OTHER_KEY } from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/constants';
import type {
  FilterOption,
  MultiselectFilterSet,
  QueryParams,
} from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/types';
import {
  filterKeyToHuman,
  filterKeyToHumanHyphenated,
  selectedOptionsToQueryParams,
  setSelectedMapper,
} from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/utils';
import { jobSearchStatusKeys } from '@/components/partials/war-room-onboarding/constants';
import { JobsInquiryEmployment, JobsInquiryPosition, JobsInquiryState } from '@/types/graphql';
import type { FilterKeysActive } from './types';

export const oteRangeKeys = Object.freeze({
  OTE_MIN: 'ote_min',
  OTE_MAX: 'ote_max',
});

const POSITION_FILTER_OPTIONS: FilterOption[] = [
  {
    title: 'AEs',
    key: JobsInquiryPosition.AccountExecutive,
  },
  {
    title: 'SDRs',
    key: JobsInquiryPosition.Sdr,
  },
  {
    title: 'VP/Manager',
    key: JobsInquiryPosition.Vp,
  },
  {
    title: 'CSMs',
    key: JobsInquiryPosition.Csm,
  },
  {
    title: 'Other',
    key: POSITION_OTHER_KEY,
  },
].map(item => ({ ...item, key: item.key.toLowerCase() }));

const SCREENED_FILTER_OPTIONS: FilterOption[] = [
  {
    title: 'Yes',
    key: true,
  },
  {
    title: 'No',
    key: false,
  },
];

export const JOB_SEARCH_STATUS_FILTER_OPTIONS: FilterOption[] = [
  {
    title: filterKeyToHuman(jobSearchStatusKeys.ACTIVELY_LOOKING),
    shortTitle: 'Actively',
    key: jobSearchStatusKeys.ACTIVELY_LOOKING,
  },
  {
    title: filterKeyToHuman(jobSearchStatusKeys.PASSIVELY_LOOKING),
    shortTitle: 'Passively',
    key: jobSearchStatusKeys.PASSIVELY_LOOKING,
  },
  {
    title: filterKeyToHuman(jobSearchStatusKeys.NOT_INTERESTED),
    shortTitle: 'Not Interested',
    key: jobSearchStatusKeys.NOT_INTERESTED,
  },
];

export const EMPLOYMENT_TYPE_FILTER_OPTIONS: FilterOption[] = [
  {
    title: filterKeyToHuman(JobsInquiryEmployment.FullTime.toLowerCase()),
    key: JobsInquiryEmployment.FullTime,
  },
  {
    title: filterKeyToHumanHyphenated(JobsInquiryEmployment.SideHustle),
    key: JobsInquiryEmployment.SideHustle,
  },
];

export const filterOptions: { [K in Extract<FilterKeysActive, 'position' | 'tiers' | 'screened'>]: FilterOption[] } = {
  position: POSITION_FILTER_OPTIONS.map(setSelectedMapper([JobsInquiryPosition.AccountExecutive.toLocaleLowerCase()])),
  tiers: TIERS_FILTER_OPTIONS.map(setSelectedMapper()),
  screened: SCREENED_FILTER_OPTIONS.map(setSelectedMapper()),
};

const DEFAULT_SELECTED_JOB_SEARCH_STATUSES = [
  jobSearchStatusKeys.ACTIVELY_LOOKING,
  jobSearchStatusKeys.PASSIVELY_LOOKING,
];

export const ACTIVE_PAGE_DEFAULT_FILTERS: MultiselectFilterSet = Object.freeze({
  job_search_statuses: DEFAULT_SELECTED_JOB_SEARCH_STATUSES,
});

export const ACTIVE_PAGE_DEFAULT_FILTERS_QUERY_PARAMS: QueryParams =
  selectedOptionsToQueryParams(ACTIVE_PAGE_DEFAULT_FILTERS);
